<template>
    <v-row style="max-width: 600px; margin: 0 auto;" >
        
        <v-col id="base" md="12" style="height: 100%;" class="my-0 py-0" >
            <!-- Back button -->
            <v-row justify="start" align="center" style="height:55px; background-color: #e6e6e6;" class="pt-0">
                <v-btn @click="$router.push({ name: 'orders_delivery_man'})" icon :color="$store.state.colors.primary">
                    <v-icon x-large >mdi-chevron-left</v-icon>
                </v-btn>
            </v-row>

            <v-row class="RestoRegular mt-5 pl-6 mb-4" style="height:40px; font-size: 25px; color: #4D4D4D;">
                Pedido
            </v-row>

            <!-- Order Card -->
            <v-row>
                <v-col style="width: 100%" class="pt-0">

                    <v-row style="height: 130px; width: 95%; margin: 0 auto; background-repeat: no-repeat; background-size: cover; background-position: center;" :style="{'background-image': 'url(' + require('@/assets/resources/yoomi/test.jpg') + ')'}">
                    </v-row>

                    <v-row class="pl-2 pt-2" style="background-color: #E6E6E6; width: 95%; margin: 0 auto; border-bottom: 1px solid #E6E6E6; ">
                        <v-col align-self="start" cols="auto">
                            <v-img src="@/assets/resources/user/casa.svg" max-width="25px"></v-img>
                        </v-col>
                        <v-col style="font-size: 12px" class="">
                            <v-row class="RestoBold" style="font-size: 13px">
                                {{details.metodo_entrega}}
                            </v-row>
                            <v-row>
                                {{details.fecha_alta.substr(0,10)}}
                            </v-row>
                            <v-row>
                                Forma de pago: {{details.metodo_pago}}
                            </v-row>
                            <v-row>
                                Estatus: {{details.estatus}}
                            </v-row>
                        </v-col>
                    </v-row>

                    <v-row class="mt-0" v-for="(item, index) in saucers" :key="index" style="font-size: 12px; border-bottom: 2px solid black; background-color: #E6E6E6; width: 95%; margin: 0 auto;">
                        <v-col cols="auto" align-self="center" class="ml-1 mr-1" >
                            <v-row justify="center" align="center" style="background-color: white; border-radius: 3px; height: 25px; width: 35px">
                                {{item.cantidad}}
                            </v-row>
                        </v-col>
                        <v-col align-self="center">
                            <v-row class="RestoBold" style="font-size: 13px">
                                {{item.platillo}}
                            </v-row>
                            <v-row class="RestoBold" style="font-size: 10px">
                                Modificadores:
                            </v-row>
                            <v-row v-for="(i, index) in item.modificadores[0].cantidad" :key="index" style="font-size: 10px">
                                {{i.modificador}}, tipo {{i.tipo_modificador}} cant. {{i.cantidad}}
                            </v-row>
                            <v-row class="RestoBold" style="font-size: 10px">
                                Adicionales:
                            </v-row>
                            <v-row v-for="(i, index) in item.adicionales" :key="index" style="font-size: 10px">
                                {{i.adicional}} ${{i.precio_adicional}} cant. {{i.cantidad}}                        
                            </v-row>
                        </v-col>
                        <v-col cols="auto" align-self="center">
                            ${{item.precio_unitario}}
                        </v-col>
                    </v-row>
                    <v-row class="mt-0" style="background-color: #E6E6E6; width: 95%; margin: 0 auto;">
                        <v-col class="pl-12" style="font-size: 13px"> 
                            <v-row style="font-size: 20px">
                                <v-col class="py-0 my-0 ml-2">
                                    <v-row justify="start" >
                                        Total:
                                    </v-row>
                                </v-col>
                                <v-col class="py-0 my-0 mr-2" align-self="center">
                                    <v-row justify="end" style="font-size: 17px;" :style="{'color':$store.state.colors.primary}">
                                        $ {{details.monto_total}}
                                    </v-row>
                                </v-col> 
                            </v-row> 
                        </v-col>
                    </v-row>

                    <v-row justify="end" style="background-color: #E6E6E6; width: 95%; margin: 0 auto;" class="pr-4 pb-4">
                        <v-btn @click="$router.push({ name: 'orders_delivery_man'})" :color="$store.state.colors.primary" dense rounded class="buttonLower mr-2" style="color: white; height: 30px; width: 120px; font-size: 12px">Volver</v-btn>
                        <v-btn :disabled="validation == true"  @click="changeStatus()" :color="$store.state.colors.primary" dense rounded class="buttonLower ml-2" style="color: white; height: 30px; width: 120px; font-size: 12px">Cambiar Estado</v-btn>
                    </v-row>
                    <v-alert :value="alert2" type="error" transition="scale-transition">
                        {{alertMessage2}}
                    </v-alert>
                    <v-alert :value="alert" type="success" transition="scale-transition">
                        {{alertMessage}}
                    </v-alert>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>
  export default {
    name: 'statusOrderDelivery',

    data: () => ({
      status:'En camino',
      num_order: '123',
      delivery_man_name: 'Pablo',
      order_place: 'Eje 4 Sur 1234 Int 6 Col. Letrán Valle',
      order_date: 'Martes 5 de Mayo 2020 a las 16:45Hrs',
      order_method: 'En la puerta de tu casa'
    }),
    methods:{
        changeStatus()
        {

        }
    }
  }
</script>

<style scoped>
  p{
    text-align: center;
    color: #555555;
  }
  h1{
    text-align: center;
    color: gray;
  }
</style>